import {useZeroProps} from '@/shared/integrations/zero/use-zero-props'
import {ZeroProvider as ZProvider} from '@rocicorp/zero/react'
import {PropsWithChildren} from 'react'

export function ZeroProvider({children}: PropsWithChildren) {
  const props = useZeroProps()
  return <ZProvider {...props}>{children}</ZProvider>
}
